import React from "react";
import { Card, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { getDesprecio, CurrencyFormatter } from "app/components/helpers/Views";
import { toast } from "react-toastify";
import getCustomToastOptions from "app/components/helpers/getCustomToastOptions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
import { useStore } from "react-redux";
import { useEffect, useState } from "react";
import { safeReplace } from "app/utils/utils";
import { update, push, getDatabase, set, ref as firebaseRef } from "firebase/database";
import Switch from "react-switch";
import useAuth from "app/hooks/useAuth";
import { insertarEnAdminCommunities } from "../comunidad/FuncionesComunidades";
import { useFirebase } from "app/firebase/context";
import { useNavigate } from "react-router-dom";
const circleBadgeStyle = {
  display: "inline-block",
  width: "30px",
  height: "30px",
  borderRadius: "50%",
  backgroundColor: "#172983", // Puedes cambiar el color según tus preferencias
  color: "#fff",
  textAlign: "center",
  lineHeight: "30px",
};

const firebaseConfigAdmin = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_DATABASE_ADMIN_URL,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};
export const Step1 = ({ onNext, plan, planHistorico, setPlan, isModalOpen, setModalOpen }) => {
  const [loading, setLoading] = useState(false);
  const planesPrecios = plan.tablaPrecios;
  const firebase = useFirebase();
  console.log("EL PLAN CLAUDET", plan);
  const store = useStore();
  const navigate = useNavigate();
  const lengu = store.getState().lenguajes;
  const diccionario = lengu.diccionario;
  let [textoVecinos, setTextoVecinos] = useState("");
  const { user } = useAuth();
  const handleOpenPdf = () => {
    const fileUrl = "/assets/files/tabla_de_precios.pdf"; // Reemplaza con la ruta correcta de tu archivo
    const newWindow = window.open(fileUrl, "_blank");

    if (newWindow) {
      newWindow.focus();
    } else {
      toast.error(diccionario.ErrorAbrirNuevaVentana, getCustomToastOptions(toast, "error"));
    }
  };

  useEffect(() => {
    setTextoVecinos(
      diccionario.preciosPorVecino
        ? safeReplace(diccionario.preciosPorVecino, "${var1}", plan.vecinos)
        : plan.vecinos
    );
  }, []);

  const handleStep = async () => {
    if (plan.Activada && !plan.pagosActivados) {
      setLoading(true);
      try {
        // Actualizar el estado con la información obtenida
        const currentDate = new Date();
        const formattedDate = currentDate.toLocaleString("es-ES", {
          year: "2-digit",
          month: "2-digit",
          day: "2-digit",
        });

        const comUpdatear = firebase.getReferencia(`Comunidad/${plan.idInterno}`, null);
        const updatedData = {
          Alta: true,
          fechaAlta: formattedDate,

          ContratoActivo: {
            fechaInicio: formattedDate,
            fechaFin: null,
            formapago: plan.formapago,
            iban: plan.iban, // MIRAR SI HABRÍA QUE GUARDAR EL IBAN EN EL MOMENTO DE CONTRATAR (SEGURAMENTE SI, Y TENER EN CUENTA )
            plan: "total",
            precioSelected: 0,
            vecinos: plan.vecinos,
            cuentaBancaria: plan.cuentaBancaria,
          },
        };
        await update(comUpdatear, updatedData);
        await insertarEnAdminCommunities(
          plan.idInterno,
          user.despacho.Codigo,
          firebaseConfigAdmin,
          firebase
        );
        setLoading(false);
      } catch (error) {
        console.error("ERROR:", error);
      }

      // aqui darla de alta sin pagar

      toast.success(
        diccionario.ComunidadActivadaCorrectamente,
        getCustomToastOptions(toast, "success")
      ); // RESETEAR EL FORM DE CONTRATACION
      navigate("/tutorial" + "/" + plan.idInterno);

      // aqui darla de alta sin pagar

      setModalOpen(!isModalOpen);
      return;
    } else if (plan.Activada && plan.pagosActivados) {
      onNext();
      return;
    }
  };
  if (loading) {
    return <div>Cargando...</div>;
  }
  return (
    <div className="alta365" style={{ marginTop: "-20px" }}>
      <div className="container mt-4">
        <div className="d-flex align-items-center paso1">
          <div style={circleBadgeStyle} className="mr-2">
            1
          </div>

          <h5 style={{ marginLeft: "15px", flex: "1", marginBottom: "0px" }}>
            {diccionario.procesoActivacionComunidad}
          </h5>
          <div>
            {/*
            <Button variant="outline-primary" onClick={handleOpenPdf}>
              <FontAwesomeIcon icon={faFilePdf} style={{ marginRight: "5px" }} />
              {diccionario.descargarPrecios}
            </Button> */}
          </div>
        </div>
      </div>
      <hr></hr>
      {plan.despachoActivado && (
        <h4>
          {diccionario.DeseasActivarComunidad}
          <span style={{ fontWeight: "bold", marginLeft: "20px" }}></span>
          <Switch
            checked={plan.Activada}
            onChange={() => setPlan({ ...plan, Activada: !plan.Activada })}
            onColor="#86d3ff"
            onHandleColor="#2693e6"
            handleDiameter={10}
            uncheckedIcon={false}
            checkedIcon={false}
            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
            activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
            height={15}
            width={28}
          />{" "}
          {plan.Activada ? (
            <span style={{ fontWeight: "bold", marginLeft: "20px" }}>Si</span>
          ) : (
            <span style={{ fontWeight: "bold", marginLeft: "20px" }}>No</span>
          )}
        </h4>
      )}

      <h4 style={{ marginTop: "20px" }}>
        {diccionario.DeseasIniciarPagosComunidad}{" "}
        <span style={{ fontWeight: "bold", marginLeft: "20px" }}></span>
        <Switch
          // disabled={!plan.Activada || !plan.IBAN}
          checked={plan.pagosActivados}
          onChange={() =>
            setPlan({ ...plan, pagosActivados: !plan.pagosActivados, Activada: !plan.Activada })
          }
          onColor="#86d3ff"
          onHandleColor="#2693e6"
          handleDiameter={10}
          uncheckedIcon={false}
          checkedIcon={false}
          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
          height={15}
          width={28}
        />
        {plan.pagosActivados ? (
          <span style={{ fontWeight: "bold", marginLeft: "20px" }}>Si</span>
        ) : (
          <span style={{ fontWeight: "bold", marginLeft: "20px" }}>No</span>
        )}
      </h4>

      <br></br>
      <i>
        {diccionario.PrecioComunidad} {plan.nombreComunidad} {diccionario.Con} {plan.vecinos}{" "}
        {diccionario.VecinosEsDe} {plan.precioComunidad}€ {diccionario.AlMes}.
      </i>
      <br />
      {plan.IBAN ? (
        <i>
          {diccionario.NumeroCuentaBancaria} :{" "}
          <span style={{ fontWeight: "bold" }}>{plan.IBAN} </span>
        </i>
      ) : (
        <i style={{ color: "red", fontWeight: "bold" }}>{diccionario.ComunidadNoIBAN}.</i>
      )}

      <div className="alta365-planes-botones">
        <button
          className="btn btn-outline-secondary px-4"
          onClick={() => setModalOpen(false)}
          //  disabled={!plan.Activada}
        >
          {diccionario.cerrar}
        </button>
        <button
          className="btn btn-outline-primary"
          onClick={() => handleStep()}
          disabled={!plan.Activada}
        >
          {diccionario.Siguiente}
        </button>
      </div>
    </div>
  );
};

export default Step1;
